<div class="login-popup-main {{admin}}">
    <div class="login-popup">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <div class="registration-container">
            <div class="title-container">
                <div class="title">
                    <h3>{{'login.signUp' | translate | uppercase}}</h3>
                </div>
            </div>
            <div class="payment-wrapper-company">
                <div class="payment-input">
                    <div class="radio-container">
                        <input (click)="companyOrNot()" type="radio" name="radio-button" />
                        <h4>{{"shoppingCart.company" | translate}}</h4>
                    </div>
                </div>
                <div class="payment-input">
                    <div class="radio-container">
                        <input (click)="individual()" type="radio" name="radio-button" checked />
                        <h4>{{"shoppingCart.individual" | translate}}</h4>
                    </div>
                </div>
            </div>
            <form *ngIf="isCompany" [formGroup]="registrationFormCompany!" novalidate>
                <div class="registration-inputs">
                    <label>{{'login.email' | translate}}</label>
                    <input
                        formControlName="email"
                        id="email"
                        class="form-control"
                        type="email"
                        required
                        [ngStyle]="registrationFormCompany!.controls['email'].invalid && (registrationFormCompany!.controls['email'].dirty || registrationFormCompany!.controls['email'].touched) && registrationFormCompany!.controls['email'].errors?.['required'] && {'border':'1px solid red'}"
                        autofocus
                        autocomplete="email"
                    /><br />

                    <div
                        *ngIf="registrationFormCompany!.controls['email'].invalid && (registrationFormCompany!.controls['email'].dirty || registrationFormCompany!.controls['email'].touched)"
                        class="alert-email"
                    >
                        <div *ngIf="registrationFormCompany!.controls['email'].errors?.['required']">
                            <small>{{ 'login.emailRequired' | translate }}</small>
                        </div>
                        <small class="text-danger" *ngIf="registrationFormCompany!.get('email')!.hasError('pattern')">
                            Helyes email formátum: "info@gmail.com".
                        </small>
                    </div>
                    <br />
                    <div class="password-container">
                        <div class="password">
                            <label>{{'login.password' | translate}}</label>
                            <input
                                formControlName="password"
                                id="password"
                                class="form-control"
                                required
                                [ngStyle]="registrationFormCompany!.controls['password'].invalid && (registrationFormCompany!.controls['password'].dirty ||registrationFormCompany!.controls['password'].touched) && registrationFormCompany!.controls['password'].errors?.['required'] && {'border':'1px solid red'}"
                                autofocus
                                type="password"
                                name="password"
                                autocomplete="new-password"
                            /><br />
                            <div
                                *ngIf="registrationFormCompany!.controls['password'].invalid && (registrationFormCompany!.controls['password'].dirty || registrationFormCompany!.controls['password'].touched)"
                                class="alert-password"
                            >
                                <div *ngIf="registrationFormCompany!.controls['password'].errors?.['required']">
                                    <small>{{ 'login.passwordRequired' | translate }}</small>
                                </div>
                                <small class="text-danger" *ngIf="registrationFormCompany!.get('password')!.hasError('pattern')">
                                    A jelszónak tartalmaznia kell kis-és nagybetűt és számot! '%' jelet nem.
                                </small>
                            </div>
                            <br />
                        </div>
                        <div class="password-confirm">
                            <label>{{'login.passwordConfirm' | translate}}</label>
                            <input
                                formControlName="passwordConfirm"
                                class="form-control"
                                required
                                [ngStyle]="registrationFormCompany!.controls['passwordConfirm'].invalid && (registrationFormCompany!.controls['passwordConfirm'].dirty ||registrationFormCompany!.controls['passwordConfirm'].touched) && registrationFormCompany!.controls['passwordConfirm'].errors?.['required'] && {'border':'1px solid red'}"
                                autofocus
                                type="password"
                                name="confirm_password"
                                id="confirm_password"
                                autocomplete="new-password"
                            /><br />
                            <div
                                *ngIf="registrationFormCompany!.controls['passwordConfirm'].invalid && (registrationFormCompany!.controls['passwordConfirm'].dirty || registrationFormCompany!.controls['passwordConfirm'].touched)"
                                class="alert-password"
                            >
                                <div *ngIf="registrationFormCompany!.controls['passwordConfirm'].errors?.['required']">
                                    <small>{{ 'login.passwordRequired' | translate }}</small>
                                </div>
                            </div>
                            <small [ngStyle]="{'color': 'red'}" *ngIf="password2!==passwordConfirm">{{passwordsAreNotEqual}}</small>
                            <br />
                        </div>
                    </div>
                    <div class="name">
                        <div class="last-name">
                            <label>{{'login.lastName' | translate}}</label>
                            <input
                                formControlName="lastName"
                                id="lastName"
                                class="form-control"
                                type="text"
                                required
                                [ngStyle]="registrationFormCompany!.controls['lastName'].invalid && (registrationFormCompany!.controls['lastName'].dirty || registrationFormCompany!.controls['lastName'].touched) && registrationFormCompany!.controls['lastName'].errors?.['required'] && {'border':'1px solid red'}"
                            /><br />
                            <div
                                *ngIf="registrationFormCompany!.controls['lastName'].invalid && registrationFormCompany!.controls['lastName'].dirty || registrationFormCompany!.controls['lastName'].touched"
                                class="alert-name"
                            >
                                <div *ngIf="registrationFormCompany!.controls['lastName'].errors?.['required']">
                                    <small>{{ 'login.lastNameRequired' | translate }}</small>
                                </div>
                            </div>

                            <br />
                        </div>
                        <div class="first-name">
                            <label>{{'login.firstName' | translate}}</label>
                            <input
                                formControlName="firstName"
                                id="firstName"
                                class="form-control"
                                type="text"
                                required
                                [ngStyle]="registrationFormCompany!.controls['firstName'].invalid && (registrationFormCompany!.controls['firstName'].dirty || registrationFormCompany!.controls['firstName'].touched) && registrationFormCompany!.controls['firstName'].errors?.['required'] && {'border':'1px solid red'}"
                            /><br />
                            <div
                                *ngIf="registrationFormCompany!.controls['firstName'].invalid && (registrationFormCompany!.controls['firstName'].dirty || registrationFormCompany!.controls['firstName'].touched)"
                                class="alert-name"
                            >
                                <div *ngIf="registrationFormCompany!.controls['firstName'].errors?.['required']">
                                    <small>{{ 'login.firstNameRequired' | translate }}</small>
                                </div>
                            </div>

                            <br />
                        </div>
                    </div>
                    <label>{{'login.companyName' | translate}}</label>
                    <input
                        type="text"
                        formControlName="companyName"
                        id="companyName"
                        class="form-control"
                        required
                        [ngStyle]="registrationFormCompany!.controls['companyName'].invalid && (registrationFormCompany!.controls['companyName'].dirty || registrationFormCompany!.controls['companyName'].touched) && registrationFormCompany!.controls['companyName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />
                    <div
                        *ngIf="registrationFormCompany!.controls['companyName'].invalid && (registrationFormCompany!.controls['companyName'].dirty || registrationFormCompany!.controls['companyName'].touched)"
                        class="alert-companyName"
                    >
                        <div *ngIf="registrationFormCompany!.controls['companyName'].errors?.['required']">
                            <small>{{ 'login.companyNameRequired' | translate }}</small>
                        </div>
                    </div>
                    <br />
                    <label>{{'login.taxNumber' | translate}}</label>
                    <input
                        type="text"
                        formControlName="taxNumber"
                        id="taxNumber"
                        class="form-control"
                        required
                        [ngStyle]="registrationFormCompany!.controls['taxNumber'].invalid && (registrationFormCompany!.controls['taxNumber'].dirty || registrationFormCompany!.controls['taxNumber'].touched) && registrationFormCompany!.controls['taxNumber'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />
                    <div
                        *ngIf="registrationFormCompany!.controls['taxNumber'].invalid && (registrationFormCompany!.controls['taxNumber'].dirty || registrationFormCompany!.controls['taxNumber'].touched)"
                        class="alert-taxNumber"
                    >
                        <div *ngIf="registrationFormCompany!.controls['taxNumber'].errors?.['required']">
                            <small>{{ 'login.taxNumberRequired' | translate }}</small>
                        </div>
                    </div>
                    <br />
                    <div class="zip-settlement-container">
                        <div class="zip">
                            <label>{{'login.zipcode' | translate}}</label>
                            <input
                                #zip
                                (keyup)="loadCity(zip.value)"
                                type="text"
                                formControlName="zipCode"
                                id="zipCode"
                                class="form-control"
                                required
                                [ngStyle]="registrationFormCompany!.controls['zipCode'].invalid && (registrationFormCompany!.controls['zipCode'].dirty || registrationFormCompany!.controls['zipCode'].touched) && registrationFormCompany!.controls['zipCode'].errors?.['required'] && {'border':'1px solid red'}"
                            /><br />
                            <div
                                *ngIf="registrationFormCompany!.controls['zipCode'].invalid && (registrationFormCompany!.controls['zipCode'].dirty || registrationFormCompany!.controls['zipCode'].touched)"
                                class="alert-zipCode"
                            >
                                <div *ngIf="registrationFormCompany!.controls['zipCode'].errors?.['required']">
                                    <small>{{"login.zipRequired" | translate }}</small>
                                </div>
                                <small class="text-danger" *ngIf="registrationFormCompany!.get('zipCode')!.hasError('pattern')">
                                    Helyes irányítószám: "1234" - négy darab számjegy.
                                </small>
                            </div>
                            <br />
                        </div>
                        <div class="settlement">
                            <label>{{'login.settlement' | translate}}</label>
                            <input
                                [(ngModel)]="cityName"
                                type="text"
                                formControlName="settlement"
                                id="settlement"
                                class="form-control"
                                required
                                [ngStyle]="registrationFormCompany!.controls['settlement'].invalid && (registrationFormCompany!.controls['settlement'].dirty || registrationFormCompany!.controls['settlement'].touched) && registrationFormCompany!.controls['settlement'].errors?.['required'] && {'border':'1px solid red'}"
                            /><br />
                            <div
                                *ngIf="registrationFormCompany!.controls['settlement'].invalid && (registrationFormCompany!.controls['settlement'].dirty || registrationFormCompany!.controls['settlement'].touched)"
                                class="alert-settlement"
                            >
                                <div *ngIf="registrationFormCompany!.controls['settlement'].errors?.['required']">
                                    <small>{{ 'login.cityRequired' | translate }}</small>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                    <label>{{'login.address' | translate}}</label>
                    <input
                        type="text"
                        formControlName="address"
                        id="address"
                        class="form-control"
                        required
                        [ngStyle]="registrationFormCompany!.controls['address'].invalid && (registrationFormCompany!.controls['address'].dirty || registrationFormCompany!.controls['address'].touched) && registrationFormCompany!.controls['address'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />
                    <div
                        *ngIf="registrationFormCompany!.controls['address'].invalid && (registrationFormCompany!.controls['address'].dirty || registrationFormCompany!.controls['address'].touched)"
                        class="alert-address"
                    >
                        <div *ngIf="registrationFormCompany!.controls['address'].errors?.['required']">
                            <small>{{ 'login.addressRequired' | translate }}</small>
                        </div>
                    </div>
                    <br />
                    <label>{{'login.phoneNumber' | translate}}</label>
                    <div class="phone-input" [ngStyle]="{'display':'flex','width':'100%'}">
                        <div class="phone-label">
                            <label [ngStyle]="{'margin-bottom':'0px'}">{{hungarianPhonePrefix}}</label>
                        </div>
                        <input
                            formControlName="phoneNumber"
                            id="phoneNumber"
                            class="form-control"
                            type="text"
                            required
                            [ngStyle]="registrationFormCompany!.controls['phoneNumber'].invalid && (registrationFormCompany!.controls['phoneNumber'].dirty || registrationFormCompany!.controls['phoneNumber'].touched) && registrationFormCompany!.controls['phoneNumber'].errors?.['required'] && {'border':'1px solid red'}"
                            autofocus
                        /><br />
                    </div>
                    <div
                        *ngIf="registrationFormCompany!.controls['phoneNumber'].invalid && (registrationFormCompany!.controls['phoneNumber'].dirty || registrationFormCompany!.controls['phoneNumber'].touched)"
                        class="alert-phoneNumber"
                    >
                        <div *ngIf="registrationFormCompany!.controls['phoneNumber'].errors?.['required']">
                            <small>{{ 'login.phoneNumberRequired' | translate }}</small>
                        </div>
                        <span class="text-danger" *ngIf="registrationFormCompany!.get('phoneNumber')!.hasError('pattern')">
                            Rossz telefonszám formátum!
                        </span>
                    </div>

                    <br />
                </div>
            </form>

            <form *ngIf="!isCompany" [formGroup]="registrationForm!" novalidate>
                <div class="registration-inputs">
                    <label>{{'login.email' | translate}}</label>
                    <input
                        formControlName="email"
                        id="email"
                        class="form-control"
                        type="email"
                        required
                        [ngStyle]="registrationForm!.controls['email'].invalid && (registrationForm!.controls['email'].dirty || registrationForm!.controls['email'].touched) && registrationForm!.controls['email'].errors?.['required'] && {'border':'1px solid red'}"
                        autofocus
                        autocomplete="email"
                    /><br />

                    <div
                        *ngIf="registrationForm!.controls['email'].invalid && (registrationForm!.controls['email'].dirty || registrationForm!.controls['email'].touched)"
                        class="alert-email"
                    >
                        <div *ngIf="registrationForm!.controls['email'].errors?.['required']">
                            <small>{{ 'login.emailRequired' | translate }}</small>
                        </div>
                        <small class="text-danger" *ngIf="registrationForm!.get('email')!.hasError('pattern')">
                            Helyes email formátum: "info@gmail.com".
                        </small>
                    </div>
                    <br />
                    <div class="password-container">
                        <div class="password">
                            <label>{{'login.password' | translate}}</label>
                            <input
                                formControlName="password"
                                id="password"
                                class="form-control"
                                required
                                [ngStyle]="registrationForm!.controls['password'].invalid && (registrationForm!.controls['password'].dirty ||registrationForm!.controls['password'].touched) && registrationForm!.controls['password'].errors?.['required'] && {'border':'1px solid red'}"
                                autofocus
                                type="password"
                                name="password"
                                autocomplete="new-password"
                            /><br />
                            <div
                                *ngIf="registrationForm!.controls['password'].invalid && (registrationForm!.controls['password'].dirty || registrationForm!.controls['password'].touched)"
                                class="alert-password"
                            >
                                <div *ngIf="registrationForm!.controls['password'].errors?.['required']">
                                    <small>{{ 'login.passwordRequired' | translate }}</small>
                                </div>
                                <small class="text-danger" *ngIf="registrationForm!.get('password')!.hasError('pattern')">
                                    A jelszónak tartalmaznia kell kis-és nagybetűt és számot! '%' jelet nem.
                                </small>
                            </div>
                            <br />
                        </div>
                        <div class="password-confirm">
                            <label>{{'login.passwordConfirm' | translate}}</label>
                            <input
                                formControlName="passwordConfirm"
                                class="form-control"
                                required
                                [ngStyle]="registrationForm!.controls['passwordConfirm'].invalid && (registrationForm!.controls['passwordConfirm'].dirty ||registrationForm!.controls['passwordConfirm'].touched) && registrationForm!.controls['passwordConfirm'].errors?.['required'] && {'border':'1px solid red'}"
                                autofocus
                                type="password"
                                autocomplete="new-password"
                                name="confirm_password"
                                id="confirm_password"
                            /><br />
                            <div
                                *ngIf="registrationForm!.controls['passwordConfirm'].invalid && (registrationForm!.controls['passwordConfirm'].dirty || registrationForm!.controls['passwordConfirm'].touched)"
                                class="alert-password"
                            >
                                <div *ngIf="registrationForm!.controls['passwordConfirm'].errors?.['required']">
                                    <small>{{ 'login.passwordRequired' | translate }}</small>
                                </div>
                            </div>
                            <small [ngStyle]="{'color': 'red'}" *ngIf="password2!==passwordConfirm">{{passwordsAreNotEqual}}</small>
                            <br />
                        </div>
                    </div>
                    <div class="name">
                        <div class="last-name">
                            <label>{{'login.lastName' | translate}}</label>
                            <input
                                formControlName="lastName"
                                id="lastName"
                                class="form-control"
                                type="text"
                                required
                                [ngStyle]="registrationForm!.controls['lastName'].invalid && (registrationForm!.controls['lastName'].dirty || registrationForm!.controls['lastName'].touched) && registrationForm!.controls['lastName'].errors?.['required'] && {'border':'1px solid red'}"
                            /><br />
                            <div
                                *ngIf="registrationForm!.controls['lastName'].invalid && registrationForm!.controls['lastName'].dirty || registrationForm!.controls['lastName'].touched"
                                class="alert-name"
                            >
                                <div *ngIf="registrationForm!.controls['lastName'].errors?.['required']">
                                    <small>{{ 'login.lastNameRequired' | translate }}</small>
                                </div>
                            </div>

                            <br />
                        </div>
                        <div class="first-name">
                            <label>{{'login.firstName' | translate}}</label>
                            <input
                                formControlName="firstName"
                                id="firstName"
                                class="form-control"
                                type="text"
                                required
                                [ngStyle]="registrationForm!.controls['firstName'].invalid && (registrationForm!.controls['firstName'].dirty || registrationForm!.controls['firstName'].touched) && registrationForm!.controls['firstName'].errors?.['required'] && {'border':'1px solid red'}"
                            /><br />
                            <div
                                *ngIf="registrationForm!.controls['firstName'].invalid && (registrationForm!.controls['firstName'].dirty || registrationForm!.controls['firstName'].touched)"
                                class="alert-name"
                            >
                                <div *ngIf="registrationForm!.controls['firstName'].errors?.['required']">
                                    <small>{{ 'login.firstNameRequired' | translate }}</small>
                                </div>
                            </div>

                            <br />
                        </div>
                    </div>
                    <div class="zip-settlement-container">
                        <div class="zip">
                            <label>{{'login.zipcode' | translate}}</label>
                            <input
                                #zip
                                (keyup)="loadCity(zip.value)"
                                type="text"
                                formControlName="zipCode"
                                id="zipCode"
                                class="form-control"
                                required
                                [ngStyle]="registrationForm!.controls['zipCode'].invalid && (registrationForm!.controls['zipCode'].dirty || registrationForm!.controls['zipCode'].touched) && registrationForm!.controls['zipCode'].errors?.['required'] && {'border':'1px solid red'}"
                            /><br />
                            <div
                                *ngIf="registrationForm!.controls['zipCode'].invalid && (registrationForm!.controls['zipCode'].dirty || registrationForm!.controls['zipCode'].touched)"
                                class="alert-zipCode"
                            >
                                <div *ngIf="registrationForm!.controls['zipCode'].errors?.['required']">
                                    <small>{{"login.zipRequired" | translate }}</small>
                                </div>
                                <small class="text-danger" *ngIf="registrationForm!.get('zipCode')!.hasError('pattern')">
                                    Helyes irányítószám: "1234" - négy darab számjegy.
                                </small>
                            </div>
                            <br />
                        </div>
                        <div class="settlement">
                            <label>{{'login.settlement' | translate}}</label>
                            <input
                                [(ngModel)]="cityName"
                                type="text"
                                formControlName="settlement"
                                id="settlement"
                                class="form-control"
                                required
                                [ngStyle]="registrationForm!.controls['settlement'].invalid && (registrationForm!.controls['settlement'].dirty || registrationForm!.controls['settlement'].touched) &&registrationForm!.controls['settlement'].errors?.['required'] && {'border':'1px solid red'}"
                            /><br />
                            <div
                                *ngIf="registrationForm!.controls['settlement'].invalid && (registrationForm!.controls['settlement'].dirty || registrationForm!.controls['settlement'].touched)"
                                class="alert-settlement"
                            >
                                <div *ngIf="registrationForm!.controls['settlement'].errors?.['required']">
                                    <small>{{ 'login.cityRequired' | translate }}</small>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                    <label>{{'login.address' | translate}}</label>
                    <input
                        type="text"
                        formControlName="address"
                        id="address"
                        class="form-control"
                        required
                        [ngStyle]="registrationForm!.controls['address'].invalid && (registrationForm!.controls['address'].dirty || registrationForm!.controls['address'].touched) && registrationForm!.controls['address'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />
                    <div
                        *ngIf="registrationForm!.controls['address'].invalid && (registrationForm!.controls['address'].dirty || registrationForm!.controls['address'].touched)"
                        class="alert-address"
                    >
                        <div *ngIf="registrationForm!.controls['address'].errors?.['required']">
                            <small>{{ 'login.addressRequired' | translate }}</small>
                        </div>
                    </div>
                    <br />
                    <label>{{'login.phoneNumber' | translate}}</label>
                    <div class="phone-input" [ngStyle]="{'display':'flex','width':'100%'}">
                        <div class="phone-label">
                            <label [ngStyle]="{'margin-bottom':'0px'}">{{hungarianPhonePrefix}}</label>
                        </div>
                        <input
                            formControlName="phoneNumber"
                            id="phoneNumber"
                            class="form-control"
                            type="text"
                            required
                            [ngStyle]="registrationForm!.controls['phoneNumber'].invalid && (registrationForm!.controls['phoneNumber'].dirty || registrationForm!.controls['phoneNumber'].touched) && registrationForm!.controls['phoneNumber'].errors?.['required'] && {'border':'1px solid red'}"
                            autofocus
                        /><br />
                    </div>
                    <div
                        *ngIf="registrationForm!.controls['phoneNumber'].invalid && (registrationForm!.controls['phoneNumber'].dirty || registrationForm!.controls['phoneNumber'].touched)"
                        class="alert-phoneNumber"
                    >
                        <div *ngIf="registrationForm!.controls['phoneNumber'].errors?.['required']">
                            <small>{{ 'login.phoneNumberRequired' | translate }}</small>
                        </div>
                        <span class="text-danger" *ngIf="registrationForm!.get('phoneNumber')!.hasError('pattern')">
                            Rossz telefonszám formátum!
                        </span>
                    </div>

                    <br />
                </div>
            </form>

            <!-- <pw-recaptcha></pw-recaptcha> -->

            <div class="newsletter-aszf">
                <div class="news">
                    <mat-checkbox (click)="getNewsLetterOrNot()" [ngStyle]="{ 'font-weight': 'bold' }">
                        <b>{{"shoppingCart.newsLetter" | translate}}</b></mat-checkbox
                    >
                    <!-- <input (click)="getNewsLetterOrNot()" type="checkbox" /> -->
                </div>
                <div class="aszf">
                    <mat-checkbox (click)="applyAszfOnClick()" [ngStyle]="{ 'font-weight': 'bold' }">
                        <b>
                            {{"shoppingCart.aszfContentFirst" | translate}}
                            <a href="./assets/documents/multiverzum_aszf.pdf" target="_blank"
                                ><small>{{"shoppingCart.aszfContentSecond" | translate}}</small></a
                            >
                            {{"shoppingCart.aszfContentThird" | translate}}
                            <small
                                ><a href="./assets/documents/adatkezelesi_tajekoztato.pdf" target="_blank"
                                    >{{"shoppingCart.privacyPolicy" | translate}}</a
                                ></small
                            >

                            {{"shoppingCart.aszfContentFifth" | translate}}
                        </b></mat-checkbox
                    >
                    <!-- <input (click)="applyAszfOnClick()" type="checkbox" /> -->
                </div>
            </div>
            <div *ngIf="isAszfCheckBoxRed" class="error">{{errorMessage}}</div>

            <div *ngIf="!isCompany" class="registration-button">
                <button (click)="register()" [disabled]="!registrationForm?.valid">{{'login.signUpp' | translate}}</button>
            </div>

            <div *ngIf="isCompany" class="registration-button">
                <button (click)="registerCompany()" [disabled]="!registrationFormCompany?.valid">{{'login.signUpp' | translate}}</button>
            </div>
        </div>
    </div>
</div>
